import React from "react";
import HeroSection from "../components/HeroSection";
import GoGreenSection from "../components/GoGreenSection";
import WhySolarSection from "../components/WhySolarSection";
import AboutSection from "../components/AboutSection";
import ServicesSection from "../components/ServicesSection";
import TestimonialsSection from "../components/TestimonialsSection";
import ContactFormSection from "../components/ContactFormSection";
import PopupForm from "../components/PopupForm";
import { Helmet } from "react-helmet-async";
import { SOCIAL_IMAGE } from "../lib/seo";

const HomePage = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Savorka Solar",
    "url": "https://www.savorka.in/",
    "logo": "https://www.savorka.in/logo.png",
    "description":
      "Savorka Solar is a renewable energy company providing rooftop, on-grid, off-grid, and hybrid solar solutions for residential, commercial, and industrial sectors in India.",
    "foundingDate": "2016",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Teachers Colony",
      "addressLocality": "Bulandshahr",
      "addressRegion": "Uttar Pradesh",
      "postalCode": "203001",
      "addressCountry": "IN",
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+91-7017774339",
      "contactType": "customer support",
      "areaServed": "IN",
      "availableLanguage": ["English", "Hindi"],
    },
    "sameAs": [
      "https://www.instagram.com/its_savorkasolar",
      "https://www.facebook.com/profile.php?id=61586037744597",
      "https://www.linkedin.com/company/savorka-solar/",
    ],
  };

  return (
    <>
      <Helmet>
  {/* Primary SEO */}
  <title>
    Solar Company in Noida & Delhi NCR | Rooftop Solar Solutions | Savorka Solar
  </title>

  <meta
    name="description"
    content="Looking for a trusted solar company in Noida? Savorka offers expert solar panel installation and Solar EPC solutions for homes and businesses. Get a free consultation today."
  />

  <meta
    name="keywords"
    content="solar company in noida, Solar Company in Noida & Delhi NCR, solar panel installation, solar companies in delhi ncr, solar panel installation services, Rooftop Solar Solutions"
  />

  <meta name="robots" content="index, follow" />

  <link rel="canonical" href="https://www.savorka.in/" />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta
    property="og:title"
    content="Solar Company in Noida & Delhi NCR | Rooftop Solar Solutions | Savorka Solar"
  />
  <meta
    property="og:description"
    content="Looking for a trusted solar company in Noida? Savorka offers expert solar panel installation and Solar EPC solutions for homes and businesses."
  />
  <meta property="og:url" content="https://www.savorka.in/" />
  <meta
    property="og:image"
    content={SOCIAL_IMAGE}
  />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta
    name="twitter:title"
    content="Solar Company in Noida & Delhi NCR | Rooftop Solar Solutions | Savorka Solar"
  />
  <meta
    name="twitter:description"
    content="Looking for a trusted solar company in Noida? Savorka offers expert solar panel installation and Solar EPC solutions."
  />
  <meta
    name="twitter:image"
    content={SOCIAL_IMAGE}
  />

  {/* Schema */}
  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>

      <main>
        <PopupForm />

        <HeroSection />
        <GoGreenSection />
        <WhySolarSection />
        <AboutSection />
        <ServicesSection />
        <TestimonialsSection />

        <section className="px-16 py-12">
          {/* <ContactFormSection /> */}
        </section>
      </main>
    </>
  );
};

export default HomePage;
